import React from 'react';

const DocumentIcon = ({ className }) => {
	return (
		<svg
			width='20'
			height='18'
			viewBox='0 0 20 18'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M4.01 4C4.01 2.9 4.9 2 6 2H13.17C13.7 2 14.21 2.21 14.58 2.59L19.41 7.42C19.79 7.79 20 8.3 20 8.83V20C20 21.1 19.1 22 18 22H5.99C4.89 22 4 21.1 4 20L4.01 4ZM13 3.5V8C13 8.55 13.45 9 14 9H18.5L13 3.5Z'
				fill='#54514D'
			/>
		</svg>
	);
};

export default DocumentIcon;



// WEBPACK FOOTER //
// ./src/opencell/svgComponents/DocumentIcon.jsx